import { Megaphone } from "lucide-react";
import { NavigationLinkProps } from "../../providers/Router";
import AnnouncementDirectoryPage from "./pages/AnnouncementDirectoryPage";
import { FEATURE_ANNOUNCEMENTS } from "../../utils/UserAccessControlUtils";

const AnnouncementRouter: NavigationLinkProps[] = [
  {
    id: "0f08af4e-d760-417d-8614-484a6720d2d9",
    title: "Announcements",
    description: "",
    path: "/announcements",
    auth: true,
    sidebar: true,
    icon: Megaphone,
    component: AnnouncementDirectoryPage,
    requiredFeature: FEATURE_ANNOUNCEMENTS,
    requiredPermissions: ["ANY"],
  },
];

export default AnnouncementRouter;
